<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <el-button size="small" icon="el-icon-paperclip" round>选择文件</el-button>
      <e-ellipsis :row="1" :content="placeholder + sizeTip" hoverTip slot="tip" class="el-upload__tip"/>
    </div>
    <div v-else>
      <el-upload
        :file-list="_value"
        name="file"
        :action="actionUrl"
        :limit="maxSize"
        :multiple="maxSize > 0"
        :data="uploadParams"
        :auto-upload="true"
        :disabled="!disabled"
        :before-upload="beforeUpload">
        <el-button size="small" icon="el-icon-paperclip" round>选择文件</el-button>
        <e-ellipsis :row="1" :content="placeholder + sizeTip" hoverTip slot="tip" class="el-upload__tip"/>
      </el-upload>
      <a-upload
        v-if="false"
        name="file"
        accept="image/png, image/jpeg, image/jpg"
        :action="actionUrl"
        list-type="picture-card"
        :file-list="fileList"
        :data="uploadParams"
        :before-upload="beforeUpload"
        @preview="handlePictureCardPreview"
        @change="handleGoodsGalleryChange"
      >
        <div v-if="fileList.length < maxSize">
          <a-icon type="plus" />
          <div class="ant-upload-text">
            上传
          </div>
        </div>
      </a-upload>
    </div>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'
import { EEllipsis } from '@/components'
import { oss_token_list } from '@/api/oss_token'

export default {
  mixins: [componentMinxins],
  name: 'FileUpload',
  components: { EEllipsis },
  props: {
    placeholder: {
      type: String,
      default: '请选择附件'
    },
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    maxSize: {
      type: Number,
      default: 5
    },
    maxNumber: {
      type: Number,
      default: 10
    },
    fileTypes: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    sizeTip () {
      if (this.fileTypes.length > 0) {
        return ` | 只允许上传[${String(this.fileTypes).replaceAll(',', '、')}]格式的文件，且单个附件不超过${this.maxSize}MB`
      }
      return this.maxSize > 0 ? ` | 单个附件不超过${this.maxSize}MB` : ''
    }
  },
  data () {
    return {
      disabled: false,
      actionUrl: '',
      fileList: [],
      uploadParams: {
        'key': '',
        'policy': '',
        'OSSAccessKeyId': '',
        'success_action_status': '200',
        'signature': ''
      }
    }
  },
  mounted () {
    if (this.mode !== 'DESIGN') {
      oss_token_list().then(({ data }) => {
        this.uploadParams.OSSAccessKeyId = data.accessid
        this.uploadParams.policy = data.policy
        this.uploadParams.signature = data.signature
        this.actionUrl = 'https://static.jnzbtz.com'
      })
    }
  },
  methods: {
    beforeUpload (file) {
      // const alows = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg']
      // if (alows.indexOf(file.type) === -1) {
      //   this.$message.warning('存在不支持的图片格式')
      // }
      if (this.maxSize > 0 && file.size / 1024 / 1024 > this.maxSize) {
        this.$message.warning(`单文件最大不超过 ${this.maxSize}MB`)
      } else {
        const name = file.name
        const suffix = name.substring(name.lastIndexOf('.') + 1)
        const lastName = file.lastModified + '.' + suffix
        this.uploadParams.key = file.uid + '_' + lastName
        return true
      }
      return false
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview (file) {
      console.log(file)
    },
    handleDownload (file) {
      console.log(file)
    },
    handleGoodsGalleryChange ({ fileList, file }) {
      this.fileList = fileList
    }
  }
}
</script>

<style lang="less" scoped>

</style>
